import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

import { fieldSizes, fieldStyle } from "./input-definition"

export const NumberInput: ComponentMultiStyleConfig = {
  parts: ["root", "field", "stepperGroup", "stepper"],
  variants: {
    outline: {
      field: {
        ...fieldStyle,
        marginRight: "-1.75rem",
      },
      root: {
        position: "static",
        bg: "transparent",
        flexDirection: "row",
        display: "flex",
        alignItems: "center",
      },
      stepperGroup: {
        position: "relative",
        zIndex: 1,
      },
      stepper: {
        borderColor: "transparent",
        color: "textMuted",
      },
    },
  },
  sizes: {
    // Width kept as before the design system migration (fixed 6rem numeric fields).
    md: {
      field: {
        ...fieldSizes.md,
        w: "6rem",
      },
    },
    sm: {
      field: {
        ...fieldSizes.sm,
        w: "6rem",
      },
    },
  },
  defaultProps: {
    size: "md",
    variant: "outline",
  },
}
